<template>
  <div :class="['axiome-logique-container', 'axiome-logique-min-qualified-cardinality']">
    <!--Affichage OnProperty-->

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" />
    </div>

    <template v-if="onPropertyBlanknodes.length">
      <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" />
    </template>

    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">min</span>


    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="minQualifiedCardinalityLiterals" :leftMargin="false"
        :showLanguageBadge="showLanguageBadge" />
    </div>


    <!--Affichage onClass-->

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onClassLiterals" :leftMargin="false" />
      <template v-if="onClassBlanknodes.length">
        <AttributeBlankNode :blankNodes="onClassBlanknodes" :leftMargin="false" :braceDisplay="true"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>

    <!--Affichage onDataRange-->

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onDataRangeLiterals" :leftMargin="false" />
      <AttributeBlankNode :blankNodes="onDataRangeBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeMinQualifiedCardinality",
  computed: {
    minQualifiedCardinalityLiterals() {
      let result = [];
      this.minQualifiedCardinality.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    onClassLiterals: {
      type: Array,
      default: () => []
    },
    onClassBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    minQualifiedCardinality: {
      type: Array,
      default: () => []
    },
    onProperty: {
      type: Array,
      default: () => []
    },
    onDataRangeLiterals: {
      type: Array,
      default: () => []
    },
    onDataRangeBlanknodes: {
      type: Array,
      default: () => []
    },
    onClass: {
      type: Array,
      default: () => []
    },
    onDataRange: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
